import { render } from "./NewsHeader.vue?vue&type=template&id=dfc3202a&scoped=true"
import script from "./NewsHeader.vue?vue&type=script&lang=js"
export * from "./NewsHeader.vue?vue&type=script&lang=js"

import "./NewsHeader.vue?vue&type=style&index=0&id=dfc3202a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dfc3202a"

export default script